var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComment({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_417_1882)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 11.2471C23.8554 8.90709 23.0292 6.66059 21.6232 4.7845C20.2172 2.90841 18.293 1.48477 16.0877 0.68907C13.8824 -0.106627 11.4925 -0.239591 9.21256 0.306571C6.93262 0.852733 4.86234 2.05414 3.25695 3.76269C1.65156 5.47124 0.58124 7.61224 0.177941 9.92173C-0.225357 12.2312 0.055996 14.6083 0.987316 16.7598C1.91864 18.9113 3.45921 20.7433 5.41911 22.0298C7.37901 23.3164 9.67256 24.0013 12.017 24.0001H19C20.3257 23.9988 21.5967 23.4715 22.5341 22.5341C23.4715 21.5968 23.9987 20.3258 24 19.0001V11.2471ZM22 19.0001C22 19.7957 21.6839 20.5588 21.1213 21.1214C20.5587 21.684 19.7956 22.0001 19 22.0001H12.017C10.6059 21.9994 9.21084 21.7014 7.9227 21.1254C6.63455 20.5494 5.48227 19.7083 4.541 18.6571C3.59517 17.6063 2.88493 16.3655 2.45789 15.0179C2.03086 13.6702 1.8969 12.2468 2.065 10.8431C2.33044 8.62902 3.32519 6.56626 4.89244 4.98C6.45969 3.39374 8.5103 2.37419 10.721 2.08207C11.1522 2.02803 11.5864 2.00064 12.021 2.00007C14.3515 1.99372 16.6098 2.80798 18.4 4.30007C19.4455 5.16902 20.3037 6.24123 20.9225 7.4517C21.5413 8.66218 21.9079 9.98571 22 11.3421V19.0001Z",
    fill: "black",
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 9H12C12.2652 9 12.5196 8.89464 12.7071 8.70711C12.8946 8.51957 13 8.26522 13 8C13 7.73478 12.8946 7.48043 12.7071 7.29289C12.5196 7.10536 12.2652 7 12 7H8C7.73478 7 7.48043 7.10536 7.29289 7.29289C7.10536 7.48043 7 7.73478 7 8C7 8.26522 7.10536 8.51957 7.29289 8.70711C7.48043 8.89464 7.73478 9 8 9Z",
    fill: "black",
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 11H8C7.73478 11 7.48043 11.1054 7.29289 11.2929C7.10536 11.4804 7 11.7348 7 12C7 12.2652 7.10536 12.5196 7.29289 12.7071C7.48043 12.8946 7.73478 13 8 13H16C16.2652 13 16.5196 12.8946 16.7071 12.7071C16.8946 12.5196 17 12.2652 17 12C17 11.7348 16.8946 11.4804 16.7071 11.2929C16.5196 11.1054 16.2652 11 16 11Z",
    fill: "black",
    fillOpacity: 0.87
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 15H8C7.73478 15 7.48043 15.1054 7.29289 15.2929C7.10536 15.4804 7 15.7348 7 16C7 16.2652 7.10536 16.5196 7.29289 16.7071C7.48043 16.8946 7.73478 17 8 17H16C16.2652 17 16.5196 16.8946 16.7071 16.7071C16.8946 16.5196 17 16.2652 17 16C17 15.7348 16.8946 15.4804 16.7071 15.2929C16.5196 15.1054 16.2652 15 16 15Z",
    fill: "black",
    fillOpacity: 0.87
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_417_1882"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.24af7c861094d57fd8dba2377efe2f46.svg";
export { ForwardRef as ReactComponent };